import { Social as Props } from '@type-declarations/prepr';
import capitalizeFirstLetter from '@utils/capitalizeFirstLetter';

import Icon, { IconType } from './Icon';
import styles from './SocialIcon.module.scss';

export default function SocialIcon({ type, link }: Props) {
  if (!type || !link) return null;

  const formattedLink = link.startsWith('http') ? link : `https://${link}`;

  return (
    <a
      href={formattedLink}
      target="_blank"
      rel="noopener"
      itemProp="url"
      title={capitalizeFirstLetter(type)}
      aria-label={capitalizeFirstLetter(type)}
      className={styles.wrapper}
    >
      <Icon icon={type.toUpperCase() as IconType} />
    </a>
  );
}
